module.exports = __webpack_public_path__ + "static/img/6H2O.bf7c0022.png";